import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'

import s from './styles.module.scss'

interface Props {
  isHideDivider?: boolean
  isGradientText?: boolean
  title?: string
  subtitle?: string
  icon: AllIcons
}

export const TabsInfoItem = ({
  isHideDivider,
  isGradientText,
  title,
  subtitle,
  icon,
}: Props) => {
  return (
    <div className={s.infoItem}>
      <AppIcon
        id={icon}
        width={16}
        height={16}
        className={s.icon}
      />

      <div className={s.text}>
        {title && (
          <p
            className={clsx('medium-14', s.infoTitle, {
              [s.gradientText]: isGradientText,
            })}
          >
            {title}
          </p>
        )}
        {subtitle && (
          <p
            className={clsx('medium-12', s.infoDescription, {
              [s.gradientText]: isGradientText,
            })}
          >
            {subtitle}
          </p>
        )}
        {!isHideDivider && <div className={s.divider}></div>}
      </div>
    </div>
  )
}
